<template>
    <div>
        <h2 class="mt-4 mb-0">{{ t('quality-control::page.title.horiba') }}</h2>
        <b-datatable
            ref="grid"
            :key="dataTableKey"
            :columns="columns"
            :endpoint="listRoute"
            :hidden-columns="hiddenColumns"
            :initial-sort="initialSort"
            :initial-filters="initialFilters"
            class="p-0"
            has-filter-selector
            item-key="id"
        >
            <template #buttons>
                <div class="px-2">
                    <v-tooltip top transition="v-fab-transition">
                        <template #activator="{ on, attrs }">
                            <v-btn
                                v-if="can('horiba.create')"
                                color="primary"
                                icon
                                v-bind="attrs"
                                @click="getUploadValuesUrl"
                                v-on="on"
                            >
                                <v-icon>mdi-plus-circle</v-icon>
                            </v-btn>
                        </template>
                        <span>{{ t('quality-control::button.upload_values') }}</span>
                    </v-tooltip>
                </div>
            </template>
            `<template #filters="{ filters }"
                >`
                <v-col cols="4">
                    <b-filter-date
                        v-model="filters.filters.filter_created_at"
                        range
                        :label="t('quality-control::filters.label.publishing_date')"
                        @clear="onCloseDateFilter(filters, 'filter_created_at')"
                    ></b-filter-date>
                </v-col>
                <v-col cols="4">
                    <b-filter-date
                        v-model="filters.filters.filter_expires_on"
                        range
                        :label="t('quality-control::filters.label.expiration_date')"
                        @clear="onCloseDateFilter(filters, 'filter_expires_on')"
                    ></b-filter-date>
                </v-col>
            </template>
            <template #[`item.list_name`]="{ item }">
                {{ item.list_name ? item.list_name : '' }}
            </template>
            <template #[`item.created_at`]="{ item }">
                {{ item.created_at ? moment(item.created_at).format($root.dateFormat) : '' }}
            </template>
            <template #[`item.expires_on`]="{ item }">
                {{ item.expires_on ? moment(item.expires_on).format($root.dateFormat) : '' }}
            </template>
            <template #[`item.is_active`]="{ item }">
                <div class="grid-status">
                    <span>
                        {{ item.is_active ? t('default::label.active') : t('default::label.inactive') }}
                    </span>
                </div>
            </template>
            <template #[`item.file_id`]="{ item }">
                <div class="table-actions">
                    <v-tooltip top transition="v-fab-transition">
                        <template #activator="{ on, attrs }">
                            <v-btn
                                icon
                                v-bind="attrs"
                                :disabled="downloadingFile"
                                v-on="on"
                                @click="$root.goTo(downloadItemUrl(item))"
                            >
                                <v-icon>mdi-download</v-icon>
                            </v-btn>
                        </template>
                        <span>{{ t('quality-control::button.download_file') }}</span>
                    </v-tooltip>
                </div>
            </template>
        </b-datatable>
    </div>
</template>

<script>
export default {
    props: {
        listRoute: {
            type: String,
            required: true,
            default: '',
        },
        columns: {
            type: Array,
            required: true,
            default: () => [],
        },
    },
    data() {
        return {
            dataTableKey: 0,
            hiddenColumns: ['*,id'],
            initialFilters: {
                uploaded: 1,
            },
            initialSort: '-created_at',
            downloadingFile: false,
        };
    },
    methods: {
        onCloseDateFilter(filters, filter) {
            switch (filter) {
                case 'filter_created_at':
                    filters.filters.created_at = null;
                    filters.filters.filter_created_at = null;
                    break;
                case 'filter_expires_on':
                    filters.filters.expires_on = null;
                    filters.filters.filter_expires_on = null;
                    break;
                default:
                    break;
            }
        },
        getUploadValuesUrl() {
            this.$root.goTo(route('horiba.create'));
        },
        downloadItemUrl(item) {
            if (this.downloadingFile) {
                return;
            }

            this.downloadingFile = true;

            _.delay(() => {
                this.downloadingFile = false;
            }, 1500);

            return route('horiba.download', {
                file: item.file_id,
            });
        },
    },
};
</script>

<style></style>
